var impressum = "הוכחת בעלות";
var privacy = "פרטיות ותנאים משפטיים";
var recallInfo = "מידע על הקריאה חוזרת";
var signOut = "התנתק";
var he_il = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { he_il as default, impressum, privacy, recallInfo, signOut };
